import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 1rem;

  .subHeader {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;

    svg {
      height: 3rem;
      fill: #c70909;
    }

    h1 {
      margin: 0;
      font-size: 1rem;
      font-weight: 500;
      color: #c70909;
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  .containerProfiles {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-height: 10rem;
    overflow-y: auto;
    padding: 0.5rem;
    gap: 1rem;
  }
  h2,
  h3 {
    margin: 0;
    font-size: 1.3rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary};
  }

  h3 {
    padding-bottom: 1rem;
    color: #c70909;
  }

  .MuiFormGroup-root {
    display: flex;
    flex-direction: row;
  }

  .MuiRadio-root {
    height: 1rem;
    width: 1rem;

    svg {
      fill: ${({ theme }) => theme.colors.text_gray};
    }
  }

  .Mui-checked {
    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  label {
    cursor: pointer;
    margin-right: 1rem;
  }

  .groupRadio {
    width: 10rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 1rem 0;

    label {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .containerCollaborators {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    max-height: 10rem;
    overflow-y: auto;
    padding: 0.5rem;
    gap: 1rem;

    .contentCollaborators {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
      width: 100%;
      p {
        color: ${({ theme }) => theme.colors.text_gray};
        font-size: 1.2rem;
        width: 100%;
        max-width: 15rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      svg {
        height: 1rem;
        fill: ${({ theme }) => theme.colors.text_gray};
        margin-right: 0.5rem;
      }
    }
  }

  .transferConfirmation {
    display: flex;
    justify-content: center;
    margin-top: 1.5rem;
  }

  @media (max-width: 470px) {
    .groupRadio {
      width: 8rem;
    }
  }
`;
